import React, { useEffect, useState } from 'react';
import { DarkModeToggle } from './DarkModeToggle';
import storage from 'utils/storage';
import { UserStatus } from './UserStatus';

export const SidebarFooter = ({ collapsed }) => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = storage.getToken(); // get token from localStorage helper
    setToken(t);
  }, []);

  return (
    <div className="">
      {token && (
        <div className="px-2">
          <UserStatus token={token} collapsed={collapsed} />
        </div>
      )}
      <div className="px-4 py-3 text-center border-t border-white/10 space-y-2 text-xs">
        {!collapsed && (
          <div className="space-y-1">
            <div className="text-white">
              © 2025 Wire24. All rights reserved.
            </div>
          </div> 
        )}
        <div className="pt-3 flex items-center justify-center">
          <DarkModeToggle  />
        </div>
      </div>
    </div>
  );
};
